import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5320abb3&lang=scss&scoped=true"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5320abb3"]])

export default __exports__